import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="mb-6">
          <Link to="/" className="text-blue-600 hover:text-blue-800 flex items-center mb-4">
            ← Zurück zum Formular
          </Link>
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Datenschutzerklärung</h1>
          
          <div className="prose max-w-none text-gray-700 space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">Datenschutz auf einen Blick</h2>
            <p>
              Diese Hinweise geben einen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen oder unser Kontaktformular nutzen. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können.
            </p>
            <p>Diese Website verwendet keine Cookies, keine Tracking-Dienste und keine Analyse-Tools.</p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Verantwortliche Stelle</h2>
            <p>
              Nadine Rau u. Mike Trepte GbR<br />
              Bettenhäuserstraße 1<br />
              34123 Kassel<br />
              E-Mail: mike.trepte@managershop.com<br />
              Telefon: 0561 / 43027276
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Bereitstellung der Website (Netlify / Strato)</h2>
            <p>
              Die Website wird über den Dienst Netlify bereitgestellt.<br /><br />
              Netlify, Inc.<br />
              2325 3rd Street, Suite 296<br />
              San Francisco, CA 94107, USA
            </p>
            <p>
              Die Domain ist bei Strato in Deutschland registriert; die Auslieferung der Inhalte erfolgt ausschließlich über Netlify.
            </p>
            <p>
              Beim Aufruf der Website werden automatisch Server-Logfiles durch Netlify verarbeitet:<br /><br />
              – IP-Adresse (gekürzt oder anonymisiert, je nach Hosting-Konfiguration)<br />
              – Datum und Uhrzeit des Zugriffs<br />
              – Browsertyp und -version<br />
              – Betriebssystem<br />
              – aufgerufene Seiten<br />
              – Referrer-URL
            </p>
            <p>Diese Daten sind technisch erforderlich, um die Website funktionsfähig bereitzustellen.</p>
            <p>
              Aufgrund des Unternehmenssitzes von Netlify in den USA kann eine Datenübermittlung in ein Drittland nicht ausgeschlossen werden. Die Verarbeitung erfolgt auf Grundlage geeigneter Garantien, insbesondere der EU-Standardvertragsklauseln gemäß Art. 46 DSGVO.
            </p>
            <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am sicheren und stabilen Betrieb).</p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Datenerfassung über das Kontaktformular (GRETA / Questera)</h2>
            <p>
              Für das Kontaktformular nutzen wir den Dienst GRETA, ein Produkt des US-Unternehmens Questera.ai,<br />
              149 Montgomery St, San Francisco, CA 94104, USA.
            </p>
            <p>
              GRETA stellt das Formular und die technische Verarbeitung bereit, um die Daten per Webhook direkt an unser EU-basiertes System (Boost.space) zu übermitteln. GRETA speichert die Daten nicht dauerhaft. Aufgrund der technischen Einbindung kann eine Datenübermittlung in die USA nicht ausgeschlossen werden. Die Verarbeitung erfolgt unter Anwendung der EU-Standardvertragsklauseln gemäß Art. 46 DSGVO.
            </p>
            <p><strong>Erhobene Daten:</strong></p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Vor- und Nachname</li>
              <li>E-Mail-Adresse</li>
              <li>Telefonnummer (optional)</li>
              <li>Nachricht / Anliegen</li>
              <li>Produktinteresse (falls angegeben)</li>
              <li>Zustimmung zur Datenschutzerklärung</li>
              <li>Zustimmung zu Werbung (falls erteilt)</li>
            </ul>
            <p><strong>Zwecke der Verarbeitung:</strong></p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Bearbeitung der Anfrage</li>
              <li>technische Übermittlung per Webhook</li>
              <li>Kommunikation per E-Mail oder Telefon</li>
              <li>Übertragung in weitere interne Systeme (siehe Abschnitt 4)</li>
            </ul>
            <p><strong>Rechtsgrundlagen:</strong></p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</li>
              <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung)</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Weiterverarbeitung der Daten aus dem Kontaktformular</h2>
            <p>Nach Eingang der Formularanfrage werden die Daten automatisiert an folgende Dienste übermittelt:</p>
            
            <p><strong>a) Boost.space (Tschechien, EU)</strong></p>
            <p>
              Wir nutzen Boost.space, betrieben von einem Unternehmen mit Sitz in Tschechien (Europäische Union), als zentrale Datenplattform („Single Source of Truth").
            </p>
            <p><strong>Verarbeitete Daten:</strong></p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Name, E-Mail, Telefonnummer</li>
              <li>Anfrageinhalt</li>
              <li>Produktinteresse</li>
              <li>erteilte Einwilligungen (Datenschutz, Werbung)</li>
            </ul>
            <p>Boost.space verarbeitet die Daten DSGVO-konform innerhalb der EU.</p>
            <p>Rechtsgrundlagen: Art. 6 Abs. 1 lit. b und lit. f DSGVO</p>
            
            <p><strong>b) Make</strong></p>
            <p>
              Make wird zur Automatisierung der Datenübertragung zwischen GRETA, Boost.space und weiteren Systemen genutzt.
            </p>
            <p>
              Make verarbeitet ausschließlich die Daten, die zur technischen Automatisierung erforderlich sind.
            </p>
            <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an effizienter Prozesssteuerung)</p>
            
            <p><strong>c) Acumbamail (Spanien, EU)</strong></p>
            <p>
              Für E-Mail-Kommunikation und Versand nutzen wir Acumbamail, einen Dienst mit Sitz in Spanien (Europäische Union).
            </p>
            <p><strong>Übermittelte Daten:</strong></p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Name</li>
              <li>E-Mail-Adresse</li>
              <li>Telefonnummer (falls angegeben)</li>
              <li>Einwilligungen (Datenschutz, Werbung)</li>
            </ul>
            <p>
              Werbliche E-Mails erhalten Sie nur, wenn Sie dem ausdrücklich zugestimmt haben. Ohne Werbeeinwilligung erfolgt ausschließlich die notwendige Kommunikation im Rahmen Ihrer Anfrage oder Buchung.
            </p>
            <p>Rechtsgrundlagen: Art. 6 Abs. 1 lit. a und lit. b DSGVO</p>
            
            <p><strong>d) Nextcloud (Deutschland / EU)</strong></p>
            <p>
              Wir nutzen Nextcloud zur internen Dokumentenverwaltung, Terminorganisation und Datenspeicherung.
              Nextcloud wird durch uns auf Servern in Deutschland bzw. innerhalb der Europäischen Union betrieben.
            </p>
            <p><strong>Verarbeitete Daten:</strong></p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Kontakt- und Stammdaten</li>
              <li>interne Notizen</li>
              <li>Terminunterlagen</li>
              <li>Dokumente zu Anfragen oder gebuchten Leistungen</li>
            </ul>
            <p>Rechtsgrundlagen: Art. 6 Abs. 1 lit. b und lit. f DSGVO</p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Zahlungsabwicklung über Stripe</h2>
            <p>Für die Bezahlung unserer Online-Seminare verwenden wir Stripe.</p>
            <p>
              Stripe Payments Europe, Ltd.<br />
              The One Building<br />
              Lower Grand Canal Street<br />
              Dublin 2, Irland
            </p>
            <p>Stripe verarbeitet:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Name</li>
              <li>E-Mail</li>
              <li>Rechnungsinformationen</li>
              <li>Zahlungsinformationen</li>
              <li>IP-Adresse</li>
              <li>verwendetes Zahlungsmittel</li>
            </ul>
            <p>
              Stripe arbeitet DSGVO-konform und nutzt Verschlüsselungs- und Schutzmechanismen sowie EU-Standardvertragsklauseln. Es kann dabei auch zu Datenübermittlungen an Konzernunternehmen außerhalb der EU kommen; diese sind ebenfalls durch geeignete Garantien (u. a. Standardvertragsklauseln) abgesichert.
            </p>
            <p><strong>Rechtsgrundlagen:</strong></p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</li>
              <li>Art. 6 Abs. 1 lit. f DSGVO (sichere Zahlungsabwicklung)</li>
            </ul>
            <p>Weitere Informationen: <a href="https://stripe.com/de/privacy" className="text-blue-600 hover:underline">https://stripe.com/de/privacy</a></p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Speicherdauer</h2>
            <p>
              Personenbezogene Daten werden gelöscht, sobald der Zweck der Verarbeitung entfällt.
              Eine längere Speicherung erfolgt nur, wenn gesetzliche Aufbewahrungspflichten (z. B. handels- oder steuerrechtliche Vorschriften) bestehen.
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Ihre Rechte</h2>
            <p>Sie haben jederzeit das Recht auf:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Auskunft über die bei uns gespeicherten personenbezogenen Daten</li>
              <li>Berichtigung unrichtiger Daten</li>
              <li>Löschung</li>
              <li>Einschränkung der Verarbeitung</li>
              <li>Widerspruch gegen die Verarbeitung</li>
              <li>Datenübertragbarkeit</li>
            </ul>
            <p>Anfragen richten Sie an:<br />E-Mail: mike.trepte@managershop.com</p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Widerruf von Einwilligungen</h2>
            <p>
              Sie können eine erteilte Einwilligung zur Datenverarbeitung jederzeit mit Wirkung für die Zukunft per E-Mail widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt hiervon unberührt.
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Sicherheit der Datenübertragung</h2>
            <p>Diese Website nutzt SSL-/TLS-Verschlüsselung zur sicheren Übertragung von Daten.</p>
            
            <p className="mt-8 text-sm text-gray-500">Stand: November 2025<br />Diese Datenschutzinformationen werden regelmäßig überprüft und bei Bedarf aktualisiert.</p>
          </div>
          
          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link 
              to="/" 
              className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
            >
              ← Zurück zur Hauptseite
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;